import { FontOption } from './font-option';

export class FontChooserComponent {
  name: string;
  label: string;
  options: {
    [optionId: string]: FontOption;
  };
}
